/** Overlay panel – used by dropdowns, autocomplete panels */
export default {
  overlaypanel: {
    root: {
      class: [
        'bg-white',
        'border border-fp-gray-2',
        'rounded-md',
        'shadow-lg',
        'z-50',
      ],
    },
    content: {
      class: 'p-0',
    },
    closeButton: {
      class: [
        'absolute',
        'top-2',
        'right-2',
        'text-fp-gray-5',
        'hover:text-fp-gray-6',
        'w-6',
        'h-6',
        'flex',
        'items-center',
        'justify-center',
        'rounded',
        'hover:bg-fp-gray-1',
        'transition-colors',
      ],
    },
  },
}
